export default "__VITE_ASSET__3PbyPvfD__"